<template>
<div class="regular-header">

  <headerGrid>
    <div class="font-size-custom-max-48"><h1 id="font-calc-netflix">Netflix lovers</h1></div>
    <p>Omdat wij ontspanning net zo belangrijk vinden als keihard werken willen wij graag weten welke series je volgt. Ook komen wij zo meer te weten met wie we te maken hebben, wij leggen later wel uit waarom we dat handig vinden. Lang verhaal kort; selecteren maar!</p>
    <a v-scroll-to="'#netflix-grid'"><img src="../assets/Folded_Paper_asset_arrow_down.png"></a>
  </headerGrid>

  <div id="netflix-grid" class="container">
    <div class="series">
      <h2>Dit is wat ons al een tijdje bezig houdt!</h2>
      <p>Selecteer jouw optie hieronder waar jij uren mee zoet kan zijn.</p>

    <div class="contactform container serie-container">
      <form action="" name="theformTwo" class="form" id="contactFormTwo">
        <div class="serie-checkbox" v-for="(item, index) in names" :key="index">
          <input type="checkbox" :id="item.name" v-model="item.checked">
          <label :for="item.name">{{ item.name }}</label>
          </div>
          <input type="tekst" name="serie" id="serie" :value="[checkedNames]" > 
    
        <div :class="['input-group', 'form-group', isEmailValid()]">
          <label class="labelEmail" for="">Wat is je e-mailadres</label><br>
          <input class="email form-control"  type="email" v-on:keyup="checkform" name="email" id="email" autocomplete="off" @click="checkInputEmail" @blur="checkInputEmail" @keydown="checkInputEmail" v-model="email">
          <input @click="showSucces" class="submit" id="submitbutton"  type="submit" value="Verzend voorkeur" />
        </div>

      <div class="hidesucces">
        <p>Gelukt! Jouw Netflix voorkeur is goed aangekomen. Wij kijken eerst even Better Call Saul af en daarna zullen we direct reageren, beloofd ;)</p>
      </div>
      </form>
    </div>
  </div>
</div>
<footerComponent></footerComponent>

</div>

</template>

<script>
import firebase from 'firebase'
import 'firebase/firestore'

import navbar from '@/components/generalLayout/navbar.vue';
import headerGrid from '@/components/generalLayout/headerGrid.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

export default {
  name: 'netflix',

  data() {
    return {
      names: [{
        name: 'serieNameBCS',
        checked: true
      }, {
        name: 'serieNameFlash',
        checked: false
      }, {
        name: 'serieNameSuits',
        checked: false
      }],
      email: '',
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },

  components:{
    headerGrid,
    navbar,
    footerComponent
  },

  computed: {
     checkedNames () {
        return this.names.filter(item => item.checked).map(name => name.name)
     }
  },
  
  methods: {
    isEmailValid: function() {
      return (this.email == "")? "" : (this.reg.test(this.email)) ? 'has-success' : 'has-error';
    },

    checkform: function(){
    var f = document.forms["theformTwo"].elements;
    var cansubmit = true;

    for (var i = 0; i < f.length; i++) {
      if (f[i].value.length == 0) cansubmit = false;
    }

    if (cansubmit) {
      document.getElementById('submitbutton').disabled = !cansubmit;
    }
  },

 
  formSubmitted: function(){
    document.getElementById('contactFormTwo').addEventListener('submit', submitForm);
  
      function submitForm(e){      
        e.preventDefault();

        // get Values
        var serie= getInputVal('serie');
        var email = getInputVal('email');

        // Save message
        saveMessage(serie,email);
      }

      // function to get form values
      function getInputVal(id){
        return document.getElementById(id).value;
      }

      function saveMessage(serie,email){
        var messagesRef = firebase.database().ref('netflix');
          var newMessageRef = messagesRef.push();

          newMessageRef.set({
            serie: serie,
            email: email,
          });
        }
    },

  checkInputEmail: function(){
	  if (document.querySelector(".email").value == '') {
		document.querySelector(".labelEmail").classList.remove("activelabelEmail");
		} else {
		document.querySelector(".labelEmail").classList.add("activelabelEmail");
	  }	
  },

  showSucces: function(){
    var element = document.querySelector('.hidesucces');
    element.classList.add('showsucces');
  },

  },
  mounted(){
    this.formSubmitted();{   
    }
  },
}

</script>

<style lang="scss" scoped>

.series{
  h2{
    text-align: center;
    @include fluid-type(18px, 32px);
  }
  p{
    text-align: center;
    padding-bottom: layout-val-8(1);
  }

  .serie-container{
    margin: 0 auto;
    display: block;
    max-width: 668px;
  }

  .serie-checkbox{
    width: 32%;
    float: left;

    label{
      opacity: 0;
    }
  }

  #serie{
    opacity: 0;
    pointer-events: none;
  }

  input[type=checkbox] {
    display:none;
  }

  input#serieNameBCS[type=checkbox] + label, input#serieNameFlash[type=checkbox] + label, input#serieNameSuits[type=checkbox] + label{
    background-image: url("../assets/Folded_Paper_Netflix_lijst_bcs.png");
    background-size: 100%;
    border-color: white;
    background-repeat: no-repeat;
    border-style: solid;
    height: 240px;
    width: 170px;
    display:inline-block;
    padding: 0 0 0 0px;
    opacity: 0.3;
    @include transition;
    color: transparent;
  }
  input#serieNameFlash[type=checkbox] + label{
    background-image: url("../assets/Folded_Paper_Netflix_lijst_Flash.png");

  }
  input#serieNameSuits[type=checkbox] + label{
    background-image: url("../assets/Folded_Paper_Netflix_lijst_Suits.png");
  }

  input#serieNameBCS[type=checkbox]:checked + label, input#serieNameFlash[type=checkbox]:checked + label, input#serieNameSuits[type=checkbox]:checked + label{
    height: 240px;
    width: 170px;
    display:inline-block;
    padding: 0 0 0 0px;
    opacity: 1;
    @include transition;
  }

.button {
  padding: 0px 24px;
  position: relative;
  display: table;
  border-radius: 50px;
  margin: 0 auto;
  margin-top: layout-val-8(7);
  margin-bottom: layout-val-8(7);
  cursor: pointer;
  color: $black;

  p{
    padding-bottom: 0 !important;
  }

  
  &::after {
    width: 100%;
    content: "";
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    border: 1px dashed $black;
    border-radius: 50px;
    @include transition-cubic-out-back; 
  }
  
  &:hover::after {
    width: 48px;
    @include transition-cubic-out-back-combi-back;
  }

  p{
    font-weight: 900;
    opacity: 1;
  }
}

.hidesucces{
  opacity: 0;
  @include transition;
  margin-top: layout-val-8(-8);
}
.showsucces{
  opacity: 1;
  background-color: $yellow;
  padding: layout-val-8(2);
  margin-bottom: layout-val-8(4);

  @include transition;
  margin-top: layout-val-8(-4);

  p{
    padding: 0 !important;
  }
}

#submitbutton{
  max-width: 200px;
  padding: 12px 24px;
  position: relative;
  display: table;
  border-radius: 50px;
  margin: 0 auto;
  margin-top: layout-val-8(7);
  margin-bottom: layout-val-8(7);
  cursor: pointer;
  color: $black;
  border: 1px dashed #cccccc;
  @include transition;
  background-color:#eeeeee;
  color: $black;
  pointer-events: none;
}

.form-control{
  border: 1px solid #eeeeee;
  &:focus{
    border: 1px solid #cccccc;
  }
}

.has-success{
  .form-control {
    border-color: $yellow;
    @include transition;
  }

  #submitbutton{
    pointer-events: all;
    color:$black;
    background-color: $white;
    border: 1px dashed $yellow;


    &:hover {
      border-color: $yellow;
      @include transition;
      transform: scale(0.9);
    }
  }
}

.form-group{
  position: relative;
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
  margin-top:-30px;
  
  input{
    height: 55px;
    width: 100%;
    margin: 8px auto;
    display: block;
  }

  label {
    transition: all 0.3s ease;
    @include pos-center($axis: 'both');
    top:64px;
    text-align: center;
    display: block;
    pointer-events:none;
  }
  input {
    transition: all 0.3s ease;
    border: 1px solid #eeeeee;
    display: block;
    width: 100%;
    text-align:center;
    font-family: 'futura-pt', sans-serif;

    &:focus {
      outline: none;
    }
  }

  .activelabelEmail{
    transition: all 0.3s ease;
    color: $grey;
    top:8px;
    left:0;
    transform: none;
  }
}

.mail-form{
  position: relative;
  max-width: 550px;
  display: block;
  margin: 0 auto;
  margin-top: layout-val-8(4);

  input{
    height: 55px;
    width: 100%;
    margin: 0 auto;
    display: block;

     &:focus {
      outline: none;
    }
  }

  label {
    @include transition;
    @include pos-center($axis: 'both');
    top:45%;
    text-align: center;
    display: block;
  }
  .activelabelName {
    @include transition;
    color: $grey;
    top:-45%;
    left:0;
    transform: none;
  }
}
}

@media screen and (max-width: 640px) {
  .series .serie-checkbox {
    width: 100%;
    float: none;
    margin: 0 auto;
    display: block;
  }
  .serie-checkbox{
    label{
      margin: 0 auto;
      display: block !important;
    }
  }
}
</style>
